import { render, staticRenderFns } from "./assess.vue?vue&type=template&id=67a4b460&scoped=true"
import script from "./assess.vue?vue&type=script&lang=js"
export * from "./assess.vue?vue&type=script&lang=js"
import style0 from "./assess.vue?vue&type=style&index=0&id=67a4b460&prod&scoped=true&lang=css"
import style1 from "./assess.vue?vue&type=style&index=1&id=67a4b460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a4b460",
  null
  
)

export default component.exports